






























import { Component, Vue, Prop } from "vue-property-decorator";
import { AssetRepository, AssetEnum } from "@/lib/AssetRepository";

@Component
export default class InstructionCard extends Vue {
  @Prop({ default: "Anleitung" })
  instructionTitle!: string;

  @Prop()
  instructionText!: string;

  @Prop()
  instructionPictures!: AssetEnum[];

  @Prop()
  instructionImageSrcs?: string[];

  @Prop()
  instructionVideoSrc?: string;

  clicked() {
    this.$emit("clicked", true);
  }

  get hasOneImage(): boolean {
    if (this.instructionImageSrcs) {
      return this.instructionImageSrcs.length == 1;
    }

    if (this.instructionPictures) {
      return this.instructionPictures.length == 1;
    }

    return false;
  }

  get hasMultipleImages(): boolean {
    if (this.instructionImageSrcs) {
      return this.instructionImageSrcs.length >= 2;
    }

    if (this.instructionPictures) {
      return this.instructionPictures.length >= 2;
    }

    return false;
  }

  get instructionPicturesImages(): string[] {
    const images: string[] = [];

    if (this.instructionImageSrcs) {
      return this.instructionImageSrcs;
    }

    if (!this.instructionPictures) {
      return images;
    }

    for (const picture of this.instructionPictures) {
      const asset = AssetRepository.getAsset(this.$vuetify.theme.dark, picture);
      images.push(asset);
    }

    return images;
  }
}
